export default __webpack_public_path__ + "static/media/babymilestoneImg4.31f1af7c.png";